import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { UsersCollection } from "@bundles/UIAppBundle/collections";
import { Routes } from "@bundles/UIAppBundle";
import { DeleteOutlined, EditOutlined, EyeOutlined, UnorderedListOutlined, } from "@ant-design/icons";
import { AntTableSmart } from "@bluelibs/x-ui-admin";
import * as Ant from "antd";
import { features } from "../../config/features";
import { UserList } from "../../config/UserList";
export class UsersAntTableSmart extends AntTableSmart {
    constructor() {
        super(...arguments);
        this.collectionClass = UsersCollection;
    }
    getBody() {
        return UserList.getRequestBody();
    }
    getColumns() {
        const list = this.container.get(UserList);
        list.build();
        return [...list.rest(), this.getActionsColumn()];
    }
    getActionsColumn() {
        return {
            title: this.i18n.t("generics.list_actions"),
            key: "actions",
            fixed: "right",
            width: 100,
            render: (_, model) => {
                return (_jsx(Ant.Popover, Object.assign({ placement: "bottomRight", content: _jsxs("div", Object.assign({ style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        } }, { children: [_jsxs(Ant.Button, Object.assign({ type: "text", style: {
                                    width: "100%",
                                }, onClick: () => {
                                    this.router.go(Routes.USERS_VIEW, {
                                        params: { id: model._id.toString() },
                                    });
                                } }, { children: [_jsx(EyeOutlined, {}, void 0), this.i18n.t("generics.view")] }), void 0), _jsxs(Ant.Button, Object.assign({ type: "text", style: { width: "100%" }, onClick: () => {
                                    this.router.go(Routes.USERS_EDIT, {
                                        params: { id: model._id.toString() },
                                    });
                                } }, { children: [_jsx(EditOutlined, {}, void 0), this.i18n.t("generics.edit")] }), void 0), _jsx(Ant.Popconfirm, Object.assign({ title: this.i18n.t("generics.ask_confirmation"), onConfirm: () => {
                                    this.collection.deleteOne(model._id).then(() => {
                                        this.load();
                                    });
                                }, okText: this.i18n.t("generics.delete"), cancelText: this.i18n.t("generics.cancel") }, { children: _jsxs(Ant.Button, Object.assign({ type: "text", style: { width: "100%" } }, { children: [_jsx(DeleteOutlined, {}, void 0), this.i18n.t("generics.delete")] }), void 0) }), void 0)] }), void 0), style: { backgroundColor: "black !important" } }, { children: _jsx(Ant.Button, Object.assign({ type: "primary" }, { children: _jsx(UnorderedListOutlined, {}, void 0) }), void 0) }), void 0));
            },
        };
    }
    getSortMap() {
        return UserList.getSortMap();
    }
    getActionItems() {
        const actions = [];
        if (features.view) {
            actions.push({
                label: this.i18n.t("generics.view"),
                icon: _jsx(EyeOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.USERS_VIEW, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        if (features.edit) {
            actions.push({
                label: this.i18n.t("generics.edit"),
                icon: _jsx(EditOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.USERS_EDIT, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        if (features.delete) {
            actions.push({
                label: this.i18n.t("generics.delete"),
                icon: _jsx(DeleteOutlined, {}, void 0),
                confirm: this.i18n.t("generics.ask_confirmation"),
                action: (model) => {
                    this.collection.deleteOne(model._id).then(() => {
                        this.load();
                    });
                },
            });
        }
        return actions;
    }
}
